import * as amplitude from "@amplitude/analytics-browser";
import axios from "axios";
import { env } from "./patient/environment/environment";


export const initAmplitude = async () => {
  const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
  if (!apiKey) return;

  const backendUserId = localStorage.getItem("userId");
  if (!backendUserId) return;

  try {
    const response = await axios.get(
      `${env.api_Url}userDetails/getUserDetailsByUserId`,
      { params: { userId: backendUserId } }
    );

    if (response?.data?.message !== "success") return;

    const user = response.data.data || {};
    const phone = user.mobileNumber;

    // ❌ Do not init without phone
    if (!phone) {
      console.log("Amplitude not initiated: phone missing");
      return;
    }

    // ✅ Prevent multiple initialization
    if (window.__AMPLITUDE_INIT__) return;
    window.__AMPLITUDE_INIT__ = true;

    // 🚀 INIT AMPLITUDE (PHONE AS USER ID)
    amplitude.init(apiKey, {
      serverZone: "EU",
      userId: String(phone),
      defaultTracking: {
        sessions: true,
        pageViews: false,
        formInteractions: false,
        fileDownloads: false,
      },
      sessionReplay: {
        enabled: true,
        sampleRate: 0.2,        // 20% users
        maskAllInputs: true,    // PII safe
        maskAllText: true,      // PII safe
      },
    });

    // Minimal user properties
    const identify = new amplitude.Identify();
    identify.set("phone", String(phone));
    identify.set("backend_user_id", backendUserId);
    amplitude.identify(identify);

    console.log("Amplitude initialized with phone:", phone);
  } catch (error) {
    console.error("Amplitude init failed", error);
  }
};

/**
 * Track Screen View ONLY
 */
export const trackScreen = (screenName) => {
    console.log(screenName)
  if (!screenName) return;

  amplitude.logEvent(screenName, {
    screen: screenName,
    timestamp: new Date().toISOString(),
  });
};
